import { setHtml } from './css.js';
import { chosung, esc } from './grid-util.js';
import { splitMulti, joinMulti, formatMulti } from './input.js';
export class GridCheckCombo {
    /** @internal */ startCheckCombo(c, row, mode) {
        this.ccSel = new Set(splitMulti(this.valueOf(c, row), c.def.valueSeparator ?? ','));
        if (mode === 'full')
            this.ime.value = '';
        this.filterCheckCombo(mode === 'quick' ? this.ime.value : '');
    }
    /** 찾기 글자로 목록 거르기 (코드 앞부분 → 명칭 포함·초성) */
    /** @internal */ filterCheckCombo(q) {
        const ed = this.editing;
        if (!ed || ed.kind !== 'checkCombo')
            return;
        const c = this.cols[ed.ci], items = this.itemsOf(c, ed.row), s = q.trim().toLowerCase(), cho = /^[ㄱ-ㅎ]+$/.test(s);
        let list = !s ? items : items.filter(i => i.value.toLowerCase().startsWith(s) || i.label.toLowerCase().includes(s) || (cho && chosung(i.label).includes(s)));
        if (s)
            list = [...list].sort((a, b) => Number(!a.value.toLowerCase().startsWith(s)) - Number(!b.value.toLowerCase().startsWith(s)));
        this.dropItems = list.slice(0, 500);
        this.dropCol = c;
        this.dropIdx = this.dropItems.length ? 0 : -1;
        this.renderCheckCombo();
    }
    /** @internal */ renderCheckCombo() {
        const ed = this.editing, sel = this.ccSel;
        if (!ed || ed.kind !== 'checkCombo' || !sel)
            return;
        const c = this.cols[ed.ci], d = this.drop;
        d.classList.remove('og-dropv');
        d.style.width = '';
        d.style.maxHeight = '';
        d.dataset.sig = '';
        d.setAttribute('aria-multiselectable', 'true');
        d.setAttribute('aria-label', (c.def.header ?? c.id) + ' ' + this.t('여러 개 선택'));
        const max = c.def.maxSelect;
        const head = `<div class="og-cch"><button type="button" data-a="all">${this.t('전체 선택')}</button><button type="button" data-a="none">${this.t('전체 해제')}</button><span class="og-ccn">${this.t('{n}개 선택', { n: sel.size })}${max != null ? ' / ' + max : ''}</span></div>`;
        const rows = this.dropItems.length ? this.dropItems.map((it, i) => { const on = sel.has(it.value); return `<div class="og-di og-ccr${i === this.dropIdx ? ' og-dsel' : ''}" data-i="${i}" role="option" aria-selected="${on}"><span class="og-ccb${on ? ' og-on' : ''}" aria-hidden="true"></span><b>${esc(it.value)}</b><span>${esc(it.label)}</span></div>`; }).join('') : `<div class="og-dn">${this.t('일치하는 항목 없음')}</div>`;
        setHtml(d, head + `<div class="og-ccl">${rows}</div>`);
        d.hidden = false;
        // 편집 칸에는 찾기 글자가 없을 때 지금 고른 명칭이 보이게
        const sep = c.def.valueSeparator ?? ',', txt = formatMulti(joinMulti([...sel], this.itemsOf(c, ed.row), sep), this.itemsOf(c, ed.row), sep, c.def.displaySeparator ?? ', ', c.def.comboShow);
        this.ime.placeholder = txt || this.t('여러 개 선택 (Space)');
        this.positionIme();
        const list = d.querySelector('.og-ccl'), el = list?.children[this.dropIdx];
        if (el) {
            if (el.offsetTop < list.scrollTop)
                list.scrollTop = el.offsetTop;
            else if (el.offsetTop + el.offsetHeight > list.scrollTop + list.clientHeight)
                list.scrollTop = el.offsetTop + el.offsetHeight - list.clientHeight;
        }
    }
    /** 항목 하나 켜기·끄기 (maxSelect 넘으면 안내) */
    /** @internal */ toggleCheckComboItem(i) {
        const ed = this.editing, sel = this.ccSel, it = this.dropItems[i];
        if (!ed || !sel || !it)
            return;
        const max = this.cols[ed.ci].def.maxSelect;
        if (sel.has(it.value))
            sel.delete(it.value);
        else if (max != null && sel.size >= max) {
            this.showTip(this.t('최대 {n}개까지 고를 수 있습니다', { n: max }), 'warning');
            return;
        }
        else
            sel.add(it.value);
        this.dropIdx = i;
        this.renderCheckCombo();
    }
    /** 보이는(걸러진) 항목 모두 켜기·끄기 */
    /** @internal */ toggleCheckComboAll(on) {
        const ed = this.editing, sel = this.ccSel;
        if (!ed || !sel)
            return;
        const vis = this.dropItems.map(i => i.value);
        if (on == null)
            on = !vis.every(v => sel.has(v));
        const max = this.cols[ed.ci].def.maxSelect;
        if (on) {
            for (const v of vis) {
                if (max != null && sel.size >= max && !sel.has(v)) {
                    this.showTip(this.t('최대 {n}개까지 고를 수 있습니다', { n: max }), 'warning');
                    break;
                }
                sel.add(v);
            }
        }
        else
            for (const v of vis)
                sel.delete(v);
        this.renderCheckCombo();
    }
    /** 확정할 값: 고른 코드(목록 순서). 찾기 글자가 있고 가리킨 항목을 아직 안 골랐으면 그것도 (글자 입력 → Enter) */
    /** @internal */ checkComboValue() {
        const ed = this.editing;
        if (!ed || !this.ccSel)
            return null;
        const c = this.cols[ed.ci], sel = new Set(this.ccSel), it = this.dropItems[this.dropIdx];
        if (this.ime.value.trim() && it && !sel.has(it.value) && !(c.def.maxSelect != null && sel.size >= c.def.maxSelect))
            sel.add(it.value);
        return joinMulti([...sel], this.itemsOf(c, ed.row), c.def.valueSeparator ?? ',');
    }
    /** 체크 콤보 편집 중 키. 처리했으면 true */
    /** @internal */ handleCheckComboKey(e) {
        if (e.altKey)
            return false;
        const n = this.dropItems.length, ctrl = e.ctrlKey || e.metaKey;
        if (e.key === ' ' && !ctrl) {
            if (this.dropIdx >= 0)
                this.toggleCheckComboItem(this.dropIdx);
            return true;
        }
        if (ctrl && (e.key === 'a' || e.key === 'A')) {
            this.toggleCheckComboAll();
            return true;
        }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'PageDown' || e.key === 'PageUp') {
            if (!n)
                return true;
            const step = e.key === 'ArrowDown' ? 1 : e.key === 'ArrowUp' ? -1 : e.key === 'PageDown' ? 8 : -8;
            this.dropIdx = Math.max(0, Math.min(n - 1, this.dropIdx + step));
            this.renderCheckCombo();
            return true;
        }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight')
            return !this.ime.value; // 찾기 글자가 없으면 칸 이동 대신 무시
        if (e.key === 'F4') {
            this.drop.hidden ? this.renderCheckCombo() : (this.drop.hidden = true);
            return true;
        }
        return false;
    }
    /** 목록 마우스: 줄 = 켜기·끄기, 전체 선택·해제 단추 */
    /** @internal */ onCheckComboMouse(e) {
        const b = e.target.closest('button[data-a]');
        if (b) {
            this.toggleCheckComboAll(b.dataset.a === 'all');
            return;
        }
        const it = e.target.closest('.og-di');
        if (it?.dataset.i != null)
            this.toggleCheckComboItem(+it.dataset.i);
    }
}
